module.exports = __webpack_public_path__ + "static/media/project-6.c207daa9.jpg";